import { useEffect, useState } from "react";
import { PlayModes } from "./play-modes";
import { LocalView } from "./local/local-view";
import { OnlineView } from "./online/online-view";
import {
  getLocalGames,
  getOnlineGames,
} from "@/pages/subs/play/common/game-registry";
import { GameMetadata } from "@/pages/subs/play/common/game-registry";

export const PlayView = () => {
  const [localGames, setLocalGames] = useState<GameMetadata[]>([]);
  const [onlineGames, setOnlineGames] = useState<GameMetadata[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadGames = async () => {
      setLoading(true);
      const localGames = await getLocalGames();
      setLocalGames(localGames);
      const onlineGames = await getOnlineGames();
      setOnlineGames(onlineGames);
      setLoading(false);
    };

    loadGames();
  }, []);

  const [selectedMode, setSelectedMode] = useState<string | null>(null);

  if (loading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <p className="text-muted-foreground">게임 목록을 불러오는 중...</p>
      </div>
    );
  }

  // 로컬 게임 선택 시
  if (selectedMode === "local") {
    return (
      <LocalView
        games={localGames}
        goToSelectMode={() => setSelectedMode(null)}
      />
    );
  }

  // 온라인 게임 선택 시
  if (selectedMode === "online") {
    return (
      <OnlineView
        games={onlineGames}
        goToSelectMode={() => setSelectedMode(null)}
      />
    );
  }

  // 메인 화면 - 게임 모드 선택
  return <PlayModes onModeSelect={setSelectedMode} />;
};
